import React, { useState } from 'react'
import {
  Select, RadioGroup,
  Stack,
  Radio,
  Text, Box,
} from '@chakra-ui/react'
import AnkletsSizeDialog from './AnkletsSizeDialog'

const AnkletSizeSelector = ({
  label = 'Anklet Size',
  id = 'sizeSelect',
  value,
  onChange,
  isPair,
  setIsPair,
  showChart = true,
}) => {
  const [isChartOpen, setIsChartOpen] = useState(false)

  return (
    <div>


      <Box bg="#fff" py={1} borderRadius="md" width="300px">
        <Text
          fontSize="16px"
          fontWeight="normal"
          color="#000000"
          mb={2}
        >
          Choose Anklet Type:
        </Text>
        <RadioGroup
          onChange={(value) => setIsPair(value === "pair")}
          value={isPair ? "pair" : "single"}
        >
          <Stack direction="row" spacing={6}>
            <Radio
              value="single"
              colorScheme="blue"
              borderColor="#000080"
              size="md"
              _checked={{
                bg: "#000080",
                color: "white",
                borderColor: "#000080",
              }}
            >
              <Text
                color="#000000"
                fontWeight="normal"
                fontSize="16px"
              >
                Single
              </Text>
            </Radio>
            <Radio
              value="pair"
              colorScheme="blue"
              borderColor="#000080"
              size="md"
              _checked={{
                bg: "#000080",
                color: "white",
                borderColor: "#000080",
              }}
            >
              <Text
                color="#000000"
                fontWeight="normal"
                fontSize="16px"
              >
                Pair
              </Text>
            </Radio>
          </Stack>
        </RadioGroup>
      </Box>
      <div className="flex items-center gap-2 mb-2">
        <label htmlFor={id}>{label}:</label>
        {showChart && (
          <div
            className="underline cursor-pointer text-sm text-[#000080]"
            onClick={() => setIsChartOpen(true)}
          >
            Size Chart
          </div>
        )}
      </div>

      <Select
        id={id}
        value={value}
        onChange={onChange}
        required
        border="1px solid"
        _hover="none"
        className="px-4 pt-0"
        width="40"
        borderColor="[#000080]"
      >
        <option value={""}>Select Size (Indian)</option>
        <option value={"X-Small (XS)"}>X-Small (XS)</option>
        <option value={"Small (S)"}>Small (S)</option>
        <option value={"Medium (M)"}>Medium (M)</option>
        <option value={"Large (L)"}>Large (L)</option>

      </Select>

      {/* Anklet Dialog */}
      <AnkletsSizeDialog isOpen={isChartOpen} onClose={() => setIsChartOpen(false)} />
    </div>
  )
}

export default AnkletSizeSelector
